import { EntityRepository, Repository } from "typeorm";
import { AssetsPo } from "../assets-po-entity";


@EntityRepository(AssetsPo)
export class AssetsPoRepository extends Repository<AssetsPo>{

}
